// 字段说明
// name: 页面路径（对应mach.config.js中的page字段,实际路由会自动去掉c_部分）
// title：页面标题, 仅开发时阅读便利
// input： machPro2Web目录下路径，webpack单页打包用（暂未使用）
// inputImport: machPro2Web目录下路径，router用
// version: bundle版本，线上、线下
//     version: '0.0.2',
//     appLowerVersion: 100250000,
//     appUpperVersion: 2147483647,
//     machLowerVersion: '1.0.0',
//     machUpperVersion: '999.999.999'
const pageList = [
  {
    name: 'c_home_page_main',
    title: '首页',
    input: 'src/pages/homepage/home_page_main/main.tsx',
    inputImport: () => import('@m2h/pages/homepage/home_page_main/main'),
  },
  {
    name: 'c_channel_list_main',
    title: '频道页(channel_list)',
    input: 'src/pages/channel_list/main.tsx',
    inputImport: () => import('@m2h/pages/channel_list/main'),
  },
  {
    name: 'c_pick_up_page_main',
    title: '频道页(pick_up_page)',
    input: 'src/pages/homepage/pick_up_page_main/main.tsx',
    inputImport: () => import('@m2h/pages/homepage/pick_up_page_main/main')
  },
  {
    name: 'homepage_kingkong_page',
    title: '频道页(kingkong_page)',
    input: 'src/pages/homepage/kingkong_page/main.tsx',
    inputImport: () => import('@m2h/pages/homepage/kingkong_page/main'),
  },
  {
    name: 'c_fixed_price',
    title: '频道页(c_fixed_price)',
    input: 'src/pages/homepage/fixed_price/main.tsx',
    inputImport: () => import('@m2h/pages/homepage/fixed_price/main'),
  },
  {
    name: 'homepage_landingPage',
    title: '频道页(homepage_landingPage)',
    input: 'src/pages/homepage/landingPage/main.tsx',
    inputImport: () => import('@m2h/pages/homepage/landingPage/main'),
  },
  {
    name: 'mine_address',
    title: '我的地址',
    input: 'src/pages/mine/mine_address/main.tsx',
    inputImport: () => import('@m2h/pages/mine/mine_address/main'),
  },
  {
    name: 'c_shop_golden',
    title: '商户详情',
    input: 'src/pages/shop/c_shop_golden/main.tsx',
    inputImport: () => import('@m2h/pages/shop/c_shop_golden/main'),
  },
  {
    name: 'c_punctual',
    title: '准时达',
    input: 'src/pages/punctual/landing/main.tsx',
    inputImport: () => import('@m2h/pages/punctual/landing/main'),
  },
  {
    name: 'c_shop_detail',
    title: '商户信息',
    input: 'src/pages/shop/shop_detail/main.tsx',
    inputImport: () => import('@m2h/pages/shop/shop_detail/main'),
  },
  {
    name: 'c_search',
    title: '搜索页',
    input: 'src/pages/search/search/main.tsx',
    inputImport: () => import('@m2h/pages/search/search/main'),
  },
  {
    name: 'c_search_shop',
    title: '商家搜索页',
    input: 'src/pages/search/shop/main.tsx',
    inputImport: () => import('@m2h/pages/search/shop/main')
  },
  {
    name: 'c_popup_list_main',
    title: '搜索页弹窗',
    input: 'src/pages/homepage/popup_list_main/main.tsx',
    inputImport: () => import('@m2h/pages/homepage/popup_list_main/main'),
  },
  {
    name: 'c_order_confirm_golden',
    title: '提单页',
    input: 'src/pages/order/order_confirm_golden/main.tsx',
    inputImport: () => import('@m2h/pages/order/order_confirm_golden/main'),
  },
  {
    name: 'c_market_order_coupon_list1',
    title: '优惠券列表',
    input: 'src/pages/market/order_coupon_list/main.tsx',
    inputImport: () => import('@m2h/pages/market/order_coupon_list/main'),
  },
  {
    name: 'c_market_order_coupon_list',
    title: '优惠券列表',
    input: 'src/pages/coupon/OrderCoupon/main.tsx',
    inputImport: () => import('@m2h/mkt_machpro/pages/coupon/OrderCoupon/main'),
  },
  {
    name: 'c_order_list',
    title: '订单列表',
    input: 'src/pages/order/order_list/main.tsx',
    inputImport: () => import('@m2h/pages/order/order_list/main'),
  },
  {
    name: 'c_order_status_golden',
    title: '订单详情',
    input: 'src/pages/order/order_status_golden/main.tsx',
    inputImport: () => import('@m2h/pages/order/order_status_golden/main'),
  },
  {
    name: 'c_order_status',
    title: '订单详情',
    input: 'src/pages/order/order_status_golden/main.tsx',
    inputImport: () => import('@m2h/pages/order/order_status_golden/main'),
  },
  {
    name: 'c_order_refund_detail',
    title: '退款详情',
    input: 'src/pages/order/order_refund_detail/main.tsx',
    inputImport: () => import('@m2h/pages/order/order_refund_detail/main'),
  },
  {
    name: 'c_customer_service_order',
    title: '订单助手',
    input: 'src/pages/customer_service_second/customer_service_order/main.tsx',
    inputImport: () => import('@m2h/pages/customer_service_second/customer_service_order/main'),
  },
  {
    name: 'c_mine',
    title: '个人页',
    input: 'src/pages/mine/mine/main.tsx',
    inputImport: () => import('@m2h/pages/mine/mine/main'),
  },
  {
    name: 'mine_settings',
    title: '个人设置页',
    input: 'src/pages/mine/settings/main.tsx',
    inputImport: () => import('@m2h/pages/mine/settings/main'),
  },
  {
    name: 'c_shop_map',
    title: '店铺地图',
    input: 'src/pages/shop/shop_map/main.tsx',
    inputImport: () => import('@m2h/pages/shop/shop_map/main'),
  },
  {
    name: 'c_address_select_page',
    title: '编辑地址',
    input: 'src/pages/address/selector_page/main.tsx',
    inputImport: () => import('@m2h/pages/address/selector_page/main'),
  },
  {
    name: 'c_route_guidance_page',
    title: '路线指引',
    input: 'src/pages/address/route_guidance_page/main.tsx',
    inputImport: () => import('@m2h/pages/address/route_guidance_page/main'),
  },
  {
    name: 'c_address_select_popup',
    title: '地址选择弹窗',
    input: 'src/pages/address/selector_popup/main.tsx',
    inputImport: () => import('@m2h/pages/address/selector_popup/main'),
  },
  {
    name: 'c_homepage_shopLandingPage',
    title: '频道页(homepage_shopLandingPage)',
    input: 'src/pages/homepage/shopLandingPage/main.tsx',
    inputImport: () => import('@m2h/pages/homepage/shopLandingPage/main'),
  },
  {
    name: 'personal_center',
    title: '个人中心',
    input: 'src/pages/person_info',
    inputImport: () => import('@m2h/pages/person_info'),
  },
  {
    name: 'personal_center1',
    title: '个人中心1',
    input: 'src/pages/person_info/change_phone',
    inputImport: () => import('@m2h/pages/person_info/change_phone/main'),
  },
  {
    name: 'c_shop_favorites',
    title: '我的最爱',
    input: 'src/pages/shop/shop_favorites/main.tsx',
    inputImport: () => import('@m2h/pages/shop/shop_favorites/main'),
  },
  {
    name: 'c_market_my_coupon_list1',
    title: '我的优惠券',
    input: 'src/pages/market/my_coupon_list/main.tsx',
    inputImport: () => import('@m2h/pages/market/my_coupon_list/main'),
  },
  {
    name: 'c_market_my_coupon_list',
    title: '我的优惠券',
    input: 'src/pages/coupon/MyCoupon/main.tsx',
    inputImport: () => import('@m2h/mkt_machpro/pages/coupon/MyCoupon/main'),
  },
  {
    name: 'choose_location_page',
    title: '选择区域',
    input: 'src/pages/address/choose_location_page/main.tsx',
    inputImport: () => import('@m2h/pages/address/choose_location_page/main'),
  },
  {
    name: 'c_punctual_rule',
    title: 'c_punctual_rule',
    input: 'src/pages/punctual/rule/main.tsx',
    inputImport: () => import('@m2h/pages/punctual/rule/main'),
  },
  {
    name: 'c_customer_service_question',
    title: 'c_customer_service_question',
    input: 'src/pages/customer_service_second/customer_service_question/main.tsx',
    inputImport: () => import('@m2h/pages/customer_service_second/customer_service_question/main'),
  },
  {
    name: 'mine_about',
    title: 'mine_about',
    input: 'src/pages/mine/about/main.tsx',
    inputImport: () => import('@m2h/pages/mine/about/main'),
  },
  {
    name: 'c_meal_for_one_main',
    title: 'c_meal_for_one_main',
    input: 'src/pages/meal_for_one/main.tsx',
    inputImport: () => import('@m2h/pages/meal_for_one/main'),
  },
  {
    name: 'c_order_review',
    title: 'c_order_review',
    input: 'src/pages/review/order_review/main.tsx',
    inputImport: () => import('@m2h/pages/review/order_review/main'),
  },
  {
    name: 'c_order_refund',
    title: 'c_order_refund',
    input: 'src/pages/order/order_refund/main.tsx',
    inputImport: () => import('@m2h/pages/order/order_refund/main'),
  },
  {
    name: 'c_order_privacy_number',
    title: 'c_order_privacy_number',
    input: 'src/pages/order/order_privacy_number/main.tsx',
    inputImport: () => import('@m2h/pages/order/order_privacy_number/main'),
  },
  {
    name: 'c_address_change_region_popup',
    title: 'c_address_change_region_popup',
    input: 'src/pages/address/change_region_popup/main.tsx',
    inputImport: () => import('@m2h/pages/address/change_region_popup/main'),
  },
  {
    name: 'c_service_address_popup',
    title: 'c_service_address_popup',
    input: 'src/pages/address/service_address_popup/main.tsx',
    inputImport: () => import('@m2h/pages/address/service_address_popup/main'),
  },
  {
    name: 'c_customer_service',
    title: 'c_customer_service',
    input: 'src/pages/customer_service/main.tsx',
    inputImport: () => import('@m2h/pages/customer_service/main'),
  },
  {
    name: 'c_home_main_view',
    title: 'c_home_main_view',
    input: 'src/pages/homepage/home_main_view/main.tsx',
    inputImport: () => import('@m2h/pages/homepage/home_main_view/main'),
  },
  {
    name: 'c_home_page_header',
    title: 'c_home_page_header',
    input: 'src/pages/homepage/home_page_header/main.tsx',
    inputImport: () => import('@m2h/pages/homepage/home_page_header/main'),
  },
  {
    name: 'c_open_city',
    title: 'c_open_city',
    input: 'src/pages/homepage/open_city/main.tsx',
    inputImport: () => import('@m2h/pages/homepage/open_city/main'),
  },
  {
    name: 'c_area_preheat',
    title: 'c_area_preheat',
    input: 'src/pages/homepage/preheat/main.tsx',
    inputImport: () => import('@m2h/pages/homepage/preheat/main'),
  },
  {
    name: 'c_quality_special_page_main',
    title: 'c_quality_special_page_main',
    input: 'src/pages/homepage/quality_special_page_main/main.tsx',
    inputImport: () => import('@m2h/pages/homepage/quality_special_page_main/main'),
  },
  {
    name: 'c_special_newborn_page_main',
    title: 'c_special_newborn_page_main',
    input: 'src/pages/homepage/special_newborn/main.tsx',
    inputImport: () => import('@m2h/pages/homepage/special_newborn/main'),
  },
  {
    name: 'bml_tool',
    title: 'bml_tool',
    input: 'src/pages/mine/BMLTool/main.tsx',
    inputImport: () => import('@m2h/pages/mine/BMLTool/main'),
  },
  {
    name: 'c_my_review',
    title: 'c_my_review',
    input: 'src/pages/review/my_review/main.tsx',
    inputImport: () => import('@m2h/pages/review/my_review/main'),
  },
  {
    name: 'c_review_completed',
    title: 'c_review_completed',
    input: 'src/pages/review/review_completed/main.tsx',
    inputImport: () => import('@m2h/pages/review/review_completed/main'),
  },
  {
    name: 'c_shop_review_detail',
    title: 'c_shop_review_detail',
    input: 'src/pages/review/shop_review_detail/main.tsx',
    inputImport: () => import('@m2h/pages/review/shop_review_detail/main'),
  },
  {
    name: 'road_test_feedback',
    title: 'road_test_feedback',
    input: 'src/pages/road_test/tt_feedback/main.tsx',
    inputImport: () => import('@m2h/pages/road_test/tt_feedback/main'),
  },
  {
    name: 'c_shop',
    title: 'c_shop',
    input: 'src/pages/shop/c_shop/main.tsx',
    inputImport: () => import('@m2h/pages/shop/c_shop/main'),
  },
  {
    name: 'c_exp_white_list',
    title: 'c_exp_white_list',
    input: 'src/pages/tool/exp_white_list/main.tsx',
    inputImport: () => import('@m2h/pages/tool/exp_white_list/main'),
  },
  {
    name: 'c_self_add_whitelist',
    title: 'c_self_add_whitelist',
    input: 'src/pages/tool/self_add_whitelist/main.tsx',
    inputImport: () => import('@m2h/pages/tool/self_add_whitelist/main'),
  },
  {
    name: 'c_customer_service_historyMessage',
    title: 'c_customer_service_historyMessage',
    input: 'src/pages/customer_service_second/customer_service_historyMessage/main.tsx',
    inputImport: () => import('@m2h/pages/customer_service_second/customer_service_historyMessage/main'),
  },
  {
    name: 'c_customer_service_progress',
    title: 'c_customer_service_progress',
    input: 'src/pages/customer_service_second/customer_service_progress/main.tsx',
    inputImport: () => import('@m2h/pages/customer_service_second/customer_service_progress/main'),
  },
  {
    name: 'c_fixed_price_banner',
    title: 'c_fixed_price_banner',
    input: 'src/pages/homepage/fixed_price_banner/main.tsx',
    inputImport: () => import('@m2h/pages/homepage/fixed_price_banner/main'),
  },
  {
    name: 'c_nine_one_nine',
    title: 'c_nine_one_nine',
    input: 'src/pages/homepage/nine_one_nine/main.tsx',
    inputImport: () => import('@m2h/pages/homepage/nine_one_nine/main'),
  },
  {
    name: 'c_im_address_select_page',
    title: 'c_im_address_select_page',
    input: 'src/pages/im/selector_page/main.tsx',
    inputImport: () => import('@m2h/pages/im/selector_page/main'),
  },
  {
    name: 'c_fall_from_sky_popup',
    title: 'c_fall_from_sky_popup',
    input: 'src/pages/market/fall_from_sky_popup/main.tsx',
    inputImport: () => import('@m2h/pages/market/fall_from_sky_popup/main'),
  },
  {
    name: 'c_market_history_coupon_list',
    title: 'c_market_history_coupon_list',
    input: 'src/pages/market/history_coupon_list/main.tsx',
    inputImport: () => import('@m2h/pages/market/history_coupon_list/main'),
  },
  {
    name: 'c_new_user_coupon_banner',
    title: 'c_new_user_coupon_banner',
    input: 'src/pages/market/new_user_coupon_banner/main.tsx',
    inputImport: () => import('@m2h/pages/market/new_user_coupon_banner/main'),
  },
  {
    name: 'c_net_tool',
    title: 'c_net_tool',
    input: 'src/pages/mine/netTool/main.tsx',
    inputImport: () => import('@m2h/pages/mine/netTool/main'),
  },
  {
    name: 'c_transfer_check',
    title: 'c_transfer_check',
    input: 'src/pages/mine/transfer_check/main.tsx',
    inputImport: () => import('@m2h/pages/mine/transfer_check/main'),
  },
  {
    name: 'c_order_cancel_reason',
    title: 'c_order_cancel_reason',
    input: 'src/pages/order/order_cancel_reason/main.tsx',
    inputImport: () => import('@m2h/pages/order/order_cancel_reason/main'),
  },
  {
    name: 'c_order_confirm',
    title: 'c_order_confirm',
    input: 'src/pages/order/order_confirm/main.tsx',
    inputImport: () => import('@m2h/pages/order/order_confirm/main'),
  },
  {
    name: 'c_order_invoice',
    title: 'c_order_invoice',
    input: 'src/pages/order/order_invoice/main.tsx',
    inputImport: () => import('@m2h/pages/order/order_invoice/main'),
  },
  {
    name: 'c_order_map',
    title: 'c_order_map',
    input: 'src/pages/order/order_map/main.tsx',
    inputImport: () => import('@m2h/pages/order/order_map/main'),
  },
  {
    name: 'c_order_map_golden',
    title: 'c_order_map_golden',
    input: 'src/pages/order/order_map_golden/main.tsx',
    inputImport: () => import('@m2h/pages/order/order_map_golden/main'),
  },
  {
    name: 'c_shop_multi_sku_modal',
    title: 'c_shop_multi_sku_modal',
    input: 'src/pages/shop/shop_multi_sku_modal/main.tsx',
    inputImport: () => import('@m2h/pages/shop/shop_multi_sku_modal/main'),
  },
  {
    name: 'c_shop_multi_sku_modal_golden',
    title: 'c_shop_multi_sku_modal_golden',
    input: 'src/pages/shop/shop_multi_sku_modal_golden/main.tsx',
    inputImport: () => import('@m2h/pages/shop/shop_multi_sku_modal_golden/main'),
  },
  {
    name: 'c_shop_star',
    title: 'c_shop_star',
    input: 'src/pages/shop/shop_star/main.tsx',
    inputImport: () => import('@m2h/pages/shop/shop_star/main'),
  },
];

module.exports = pageList;
